<template>
    <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" m-dropdown-toggle="click">
        <a href="#" class="m-nav__link m-dropdown__toggle">
                                                <span class="m-topbar__userpic">
                                                    <img src="../../../../static/app/media/img/users/default-user.png" class="m--img-rounded m--marginless m--img-centered" alt=""/>
                                                </span>
            <span class="m-topbar__username m--hide">
                                                    {{user.firstname}}
                                                </span>
        </a>
        <div class="m-dropdown__wrapper">
            <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
            <div class="m-dropdown__inner">
                <div class="m-dropdown__header m--align-center" style="background: url(../../../../static/app/media/img/misc/user_profile_bg.jpg); background-size: cover;">
                    <div class="m-card-user m-card-user--skin-dark">
                        <div class="m-card-user__pic">
                            <img src="../../../../static/app/media/img/users/default-user.png" class="m--img-rounded m--marginless" alt=""/>
                        </div>
                        <div class="m-card-user__details">
                                                                <span class="m-card-user__name m--font-weight-500">
                                                                    {{user.lastname}} {{user.firstname}}
                                                                </span>
                            <a href="" class="m-card-user__email m--font-weight-300 m-link">
                                {{user.email}}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="m-dropdown__body">
                    <div class="m-dropdown__content">
                        <ul class="m-nav m-nav--skin-light">
                            <li class="m-nav__section m--hide">
                                                                    <span class="m-nav__section-text">
                                                                        {{$t('Section')}}
                                                                    </span>
                            </li>
                            <li class="m-nav__item">
                                <router-link to="/admin/profile" class="m-nav__link">
                                    <i class="m-nav__link-icon flaticon-profile-1"></i>
                                    <span class="m-nav__link-title">
                                                                            <span class="m-nav__link-wrap">
                                                                                <span class="m-nav__link-text">
                                                                                    {{$t('My Profile')}}
                                                                                </span>
                                                                            </span>
                                                                        </span>
                                </router-link>
                            </li>
                            <!--<li class="m-nav__item">
                                <a href="header/profile.html" class="m-nav__link">
                                    <i class="m-nav__link-icon flaticon-lifebuoy"></i>
                                    <span class="m-nav__link-text">
                                                                            {{$t('Support')}}
                                                                        </span>
                                </a>
                            </li>-->
                            <li class="m-nav__separator m-nav__separator--fit"></li>
                            <li class="m-nav__item">
                                <router-link to="/logout" class="btn m-btn--pill    btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">
                                    {{$t('Logout')}}
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
  name: 'UserProfile',
  data () {
    return {
      user: {},
      endpoints: {}
    }
  },
  created: function () {
    let self = this
    this.$http
      .get(process.env.API_URL + '/api/v1/admin/check-auth', {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        if (res.data === undefined || res.data === 'undefined') {
          localStorage.clear()
          this.$router.push('/login')
        }
        self.user = res.data
        localStorage.setItem('user', JSON.stringify(res.data))
      }).catch(res => {
        localStorage.clear()
        this.$router.push('/login')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/header/UserProfile.vue